import {
  Box,
  Paper,
  Typography,
  Grid,
  Card,
  CardHeader,
  Avatar,
  IconButton,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import React, { useEffect, useState, useContext } from "react";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import EditIcon from "@mui/icons-material/Edit";
import StarIcon from "@mui/icons-material/Star";
import { baseUrl } from "../../../services";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import moment from "moment";
import { AppDataContext } from "../../../common/appContext";
import { isShowUnitDrawer } from "../../../configs/AppSettings";

const useStyles = makeStyles((theme) => ({
  avatar: {
    background: "#1d428a",
    height: theme.spacing(10),
    width: theme.spacing(10),
  },
  CardHeader: {
    alignItems: "flex-start",
  },
  twitterIcon: { color: "#1da1f3" },
  instaIcon: { color: "#1d428a" },
  socialText: {
    display: "flex",
    columnGap: "8px",
    cursor: "pointer",
  },
  height100: {
    height: "100%",
  },
  playerCombineInfo: {
    color: "#c8102e",
  },
  playerCombineValues: {
    color: "#000",
  },
  inputTitle: {
    padding: "10px",
    fontSize: "1rem !important",
    fontFamily: "Roboto, sans-serif",
    fontWeight: "500!important",
    color: "#1d428a",
  },
  gridHeader: {
    color: "#c8102e",
    fontSize: "0.875rem",
    fontWeight: 500,
  },
  gridData: {
    fontSize: "0.875rem",
    fontWeight: 500,
    paddingTop: "8px",
  },
  gridIndent: {
    [theme.breakpoints.up("lg")]: {
      margin: "15px 20px 10px 35px",
    },
    [theme.breakpoints.down("lg")]: {
      margin: "0px 0px 10px 5px",
    },
  },
}));

export default function PlayerDetails(props) {
  const { gridPropsData, agentDetails } = props;

  const classes = useStyles();
  const [gridData, setGridData] = useState([]);
  const [agentGridData, setAgentGridData] = useState([]);
  const {
    combineYear,
    lengthUnits,
    weightUnits,
    setWeightUnits,
    setLengthUnits,
    getWeightUnitValue,
    getLengthUnitValue,
    getLengthUnitLabelType,
    getWeightUnitLabelType,
  } = useContext(AppDataContext);

  const participationType = {
    202209: "Combine Invite",
    202221: "Elite Camp Invite",
    202222: "G League Ignite",
    202211: " ",
  };

  useEffect(() => {
    let data = { ...gridPropsData };
    setGridData(data);
    let agentData = [...agentDetails];
    setAgentGridData(agentData);
  }, [gridPropsData, agentDetails]);

  useEffect(() => {
    if (isShowUnitDrawer) {
      setLengthUnits(4);
      setWeightUnits(1);
    }
  }, []);

  return (
    <Box pt={2}>
      {/* <Paper
        elevation={5}
        sx={{
          marginTop: "10px",
         width: "calc(100vw - 285px)",
          overflowX: "auto",
          whiteSpace: "nowrap",
        }}
      > */}

      <Grid container spacing={2}>
        <Grid item lg={3} md={3} xs={12}>
          {" "}
          <Card square className={classes.height100}>
            <CardHeader
              className={classes.CardHeader}
              avatar={
                <Avatar
                  className={classes.avatar}
                  src={
                    props.playerData.headshotURL
                      ? baseUrl(props.playerData.headshotURL)
                      : ""
                  }
                  alt="basketball"

                  // onClick={(e) => {
                  //   viewPlayerProfile(elem);
                  // }}
                ></Avatar>
              }
              title={
                <Typography
                  noWrap
                  variant="subtitle2"
                  component="p"
                  color="primary"
                  // className={classes.cardTextWidth}
                  // onClick={(e) => {
                  //   viewPlayerProfile(elem);
                  // }}
                >
                  {props.playerData.playerName}
                  {/* {elem.playerName} */}
                </Typography>
              }
              subheader={
                <>
                  <Typography
                    noWrap
                    variant="caption"
                    component="p"
                    // className={classes.cardTextWidth}
                    // onClick={(e) => {
                    //   viewPlayerProfile(elem);
                    // }}
                  >
                    {"DOB: "}
                    {moment(props.playerData.dob).format("MM/DD/YYYY") ===
                    "Invalid date"
                      ? "--"
                      : moment(props.playerData.dob).format("MM/DD/YYYY")}
                    {/* {elem.collegeOrClub} */}
                  </Typography>
                  <Typography variant="caption">
                    {gridData.collegeOrClub ? gridData.collegeOrClub : ""}
                  </Typography>
                  {/* <Typography variant="caption">
                    {gridData.address1 ? gridData.address1 : ""}{" "}
                    {gridData.address2 ? "," + gridData.address2 : ""}
                  </Typography> */}
                  <Box display="flex" flexWrap="wrap">
                    {props.playerData.twitter ? (
                      <Typography
                        component="span"
                        variant="subtitle2"
                        className={classes.socialText}
                        color="primary"
                      >
                        <TwitterIcon className={classes.twitterIcon} />@
                        {props.playerData.twitter}
                      </Typography>
                    ) : (
                      ""
                    )}
                    {props.playerData.instagram ? (
                      <Typography
                        component="span"
                        variant="subtitle2"
                        className={classes.socialText}
                        color="primary"
                      >
                        &nbsp;&nbsp;{" "}
                        <InstagramIcon className={classes.instaIcon} />@
                        {props.playerData.instagram}
                      </Typography>
                    ) : (
                      ""
                    )}
                  </Box>
                </>
              }
            />
          </Card>
        </Grid>

        <Grid item xs={12} md={9} lg={9}>
          <Grid container spacing={2}>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <Paper square className={classes.height100}>
                <Box p={1.5}>
                  <Typography
                    variant="subtitle1"
                    mb={1.5}
                    fontWeight="medium"
                    color="primary"
                  >
                    Combine Details
                  </Typography>
                  <Grid container>
                    <Grid item xs={3}>
                      <Typography component="p" variant="caption">
                        Participation Type
                      </Typography>
                    </Grid>
                    <Grid item xs={3}>
                      <Typography component="p" variant="caption">
                        Jersey Number
                      </Typography>
                    </Grid>
                    <Grid item xs={2}>
                      <Typography component="p" variant="caption">
                        Position
                      </Typography>
                    </Grid>

                    <Grid item xs={2}>
                      <Typography component="p" variant="caption">
                        Height {/* Height in (ft & in) */}
                      </Typography>
                    </Grid>

                    <Grid item xs={2}>
                      <Typography component="p" variant="caption">
                        Weight
                      </Typography>
                    </Grid>
                  </Grid>

                  <Grid container>
                    <Grid item xs={3}>
                      {Object.keys(gridData).length &&
                      gridData.participate.length
                        ? gridData.participate.map((elem, index) => {
                            // console.log("Bhavya ", elem);
                            if (elem.eventId === combineYear + "09") {
                              return (
                                <Typography
                                  key={`typ_${index}`}
                                  component="p"
                                  variant="subtitle2"
                                  noWrap
                                >
                                  {"Combine Invite"}
                                </Typography>
                              );
                            } else if (elem.eventId === combineYear + "21") {
                              return (
                                <Typography
                                  key={`typ_${index}`}
                                  component="p"
                                  variant="subtitle2"
                                  noWrap
                                >
                                  {"Elite Camp Invite"}
                                </Typography>
                              );
                            } else if (elem.eventId === combineYear + "22") {
                              return (
                                <Typography
                                  key={`typ_${index}`}
                                  component="p"
                                  variant="subtitle2"
                                  noWrap
                                >
                                  {"G League Ignite"}
                                </Typography>
                              );
                            } else if (elem.eventId === combineYear + "11") {
                              return (
                                <Typography
                                  key={`typ_${index}`}
                                  component="p"
                                  variant="subtitle2"
                                  noWrap
                                >
                                  {"Basketball Africa League"}
                                </Typography>
                              );
                            } else if (elem.eventId === combineYear + "23") {
                              return (
                                <Typography
                                  key={`typ_${index}`}
                                  component="p"
                                  variant="subtitle2"
                                  noWrap
                                >
                                  {"Portsmouth"}
                                </Typography>
                              );
                            }
                          })
                        : ""}
                    </Grid>
                    <Grid item xs={3}>
                      {Object.keys(gridData).length &&
                      gridData.participate.length
                        ? gridData.participate.map((elem, index) => (
                            <Typography
                              key={`typ2_${index}`}
                              component="p"
                              variant="subtitle2"
                            >
                              {elem.jersey ?? "--"}
                            </Typography>
                          ))
                        : ""}
                    </Grid>
                    <Grid item xs={2}>
                      <Typography>
                        {gridData.positionName
                          ? `${gridData.positionName}`
                          : "--"}
                      </Typography>
                    </Grid>

                    <Grid item xs={2}>
                      {/* {Object.keys(gridData).length && gridData.participate.length
                        ? gridData.participate.map((elem, index) => {
                          return ( */}
                      <Typography
                        // key={`typ2_${index}`}
                        component="p"
                        variant="subtitle2"
                      >
                        {gridData.heightInFeet
                          ? getLengthUnitValue(
                              gridData.heightInFeet,
                              gridData.heightInInches
                            )
                          : "--"}
                      </Typography>
                      {/* </Typography>
                          );
                        })
                        : ""} */}
                    </Grid>

                    <Grid item xs={2}>
                      <Typography variant="subtitle2">
                        {gridData.weight
                          ? `${getWeightUnitValue(
                              gridData.weight
                            )} ${getWeightUnitLabelType(weightUnits)}`
                          : "--"}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Paper>
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <Paper square className={classes.height100}>
                <Box p={1.5}>
                  <Typography
                    variant="subtitle1"
                    mb={1.5}
                    fontWeight="medium"
                    color="primary"
                  >
                    Agent Details
                  </Typography>
                  <Grid container>
                    <Grid item xs={4}>
                      <Box display="flex" flexDirection="column">
                        <Typography component="p" variant="caption">
                          Agency Name/Agent
                        </Typography>
                        {agentGridData.length
                          ? agentGridData.map((elem, index) => {
                              return (
                                <Typography component="p" variant="subtitle2">
                                  {elem.name ? elem.name : "---"}
                                </Typography> //  {gridData.address1 ? gridData.address1 : ""}
                              );
                            })
                          : ""}

                        {/* <Typography

                        component="p"
                        variant="caption"
                        color="primary"
                      >
                       
                      </Typography> */}
                      </Box>
                    </Grid>
                    <Grid item xs={3}>
                      <Box display="flex" flexDirection="column">
                        <Typography component="p" variant="caption">
                          Phone
                        </Typography>
                        {agentGridData.length
                          ? agentGridData.map((elem, index) => {
                              return (
                                <Typography component="p" variant="subtitle2">
                                  {elem.phone ? elem.phone : "---"}
                                </Typography>
                              );
                            })
                          : ""}
                      </Box>
                    </Grid>
                    <Grid item xs={4}>
                      <Box display="flex" flexDirection="column">
                        <Typography component="p" variant="caption">
                          Email
                        </Typography>
                        <Typography>
                          {agentGridData.length
                            ? agentGridData.map((elem, index) => {
                                return (
                                  <Typography component="p" variant="subtitle2">
                                    {elem.email ? elem.email : "---"}
                                  </Typography>
                                );
                              })
                            : ""}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      {/* </Paper> */}
    </Box>
  );
}
